import { isAxiosNetworkOrTimeoutError, isAxiosRequestCanceled } from '@/utils/isAxiosRequestCanceled';
import { isBenignApexChartsNavigationNoise } from '@/utils/apexChartsBenign';

/**
 * GET /user com 401 durante hidratação de sessão (token expirado / sem cookie Sanctum).
 * @param {import('@sentry/core').EventHint | undefined} hint
 */
export function isExpectedCheckAuthUnauthorized(hint) {
    const ex = hint?.originalException;
    if (!ex || ex.name !== 'AxiosError') {
        return false;
    }
    if (ex.response?.status !== 401) {
        return false;
    }
    const url = String(ex.config?.url ?? ex.response?.config?.url ?? '');
    return url.includes('/api/v1/user');
}

/**
 * Ruído benigno capturado pelo handler global `onerror` (ex.: Plyr dispara
 * `CustomEvent` em falhas de media element — não é uma exceção JS com stack).
 */

/**
 * @param {unknown} value
 * @returns {value is CustomEvent<any>}
 */
function isCustomEvent(value) {
    return typeof CustomEvent !== 'undefined' && value instanceof CustomEvent;
}

/**
 * Eventos de erro do Plyr chegam como CustomEvent com `detail.plyr`.
 * @param {import('@sentry/core').ErrorEvent} _event
 * @param {import('@sentry/core').EventHint | undefined} hint
 */
export function isPlyrMediaCustomErrorNoise(_event, hint) {
    const ex = hint?.originalException;
    if (isCustomEvent(ex) && ex.type === 'error') {
        const d = ex.detail;
        if (d != null && typeof d === 'object' && Object.prototype.hasOwnProperty.call(d, 'plyr')) {
            return true;
        }
    }

    const fromEvent = _event?.exception?.values?.map((v) => v?.value).filter(Boolean).join(' ') || '';
    return /CustomEvent.*type=error/i.test(fromEvent);
}

/**
 * @type {import('@sentry/vue').BrowserOptions['beforeSend']}
 */
export function sentryBeforeSend(event, hint) {
    if (isPlyrMediaCustomErrorNoise(event, hint)) {
        return null;
    }
    if (isBenignApexChartsNavigationNoise(event, hint)) {
        return null;
    }
    if (isAxiosRequestCanceled(hint?.originalException)) {
        return null;
    }
    if (isAxiosNetworkOrTimeoutError(hint?.originalException)) {
        return null;
    }
    if (isExpectedCheckAuthUnauthorized(hint)) {
        return null;
    }
    return event;
}
